module.exports = __webpack_public_path__ + "media/media/logos/enerflex-b28fcade39474b679377c7def2f7f297.png";